export default {"src":"/_next/static/media/side-yard.e4d9f825.svg","height":25,"width":30,"blurWidth":0,"blurHeight":0};